import React, { useContext } from 'react';

import { Box } from '@wds/box';
import { Typography } from '@wds/typography';

import { StaticContext } from '@sm/webassets';

import DeveloperWebBasePage from '../DeveloperWebBasePage';

import AppTable from '../../components/AppTable';

import './faq.scss';

const FAQ = () => {
  const {
    environment: { domain, subdomain },
  } = useContext(StaticContext);

  // For testing only, when this goes live to the devekoper subdomain this will not be required
  const prependUrl = subdomain !== 'developer' ? '/developer' : '';

  return (
    <div className="container-faq" data-testid="FAQ__Developer">
      <DeveloperWebBasePage id="Developer - FAQ" title="SurveyMonkey API Developer Portal">
        <div className="faq-page">
          <Box mb={6}>
            <Box my={8}>
              <Box mb={4}>
                <Typography variant="pageTitle" component="h1" align="center">
                  <strong>Frequently Asked Questions</strong>
                </Typography>
              </Box>
              <Box>
                <Typography variant="body" align="center">
                  Building an app is hard work. We&apos;ll help answer any questions that you may have.
                </Typography>
              </Box>
            </Box>

            <Box mb={6}>
              <Typography variant="cardTitle" component="h3">
                <strong>
                  What&apos;s the difference between building an app for the{' '}
                  <a href={`https://www.${domain}.com/apps`}> App Directory </a> and building an app for my team?
                </strong>
              </Typography>
              <Box my={2}>
                <Typography>
                  Based on your needs, most developers either fall into one bucket or the other. You&apos;ll find a
                  quick rundown of the differences below.
                </Typography>
              </Box>
              <Box mb={5}>
                <Typography>
                  If you&apos;re looking for more info on either camp, visit{' '}
                  <a href={`${prependUrl}/build-a-public-app/`}>Creating a Public App</a> or{' '}
                  <a href={`${prependUrl}/build-a-private-app/`}>Creating a Private App</a>.
                </Typography>
              </Box>

              <Box mb={6}>
                <AppTable />
              </Box>

              <Box>
                <Typography>
                  *Please see our <a href={`${prependUrl}/tou/`}>API Developer Terms</a> for more guidelines when
                  building with our API.
                </Typography>
              </Box>
            </Box>

            <Box mb={4}>
              <Typography variant="cardTitle" component="h3">
                <strong>How do I get support or suggest a feature for the SurveyMonkey API?</strong>
              </Typography>
              <Box>
                <Typography>
                  Reach out to our team for help or feedback by{' '}
                  <a href={`https://help.${domain}.com/contact/`}>visiting our contact page</a>.
                </Typography>
              </Box>
            </Box>

            <Box mb={4}>
              <Typography variant="cardTitle" component="h3">
                <strong>Where can I read about the SurveyMonkey API scopes?</strong>
              </Typography>
              <Box>
                <Typography>
                  Public app developers should understand which scopes they&apos;ll need. You can read more about scopes
                  in our <a href="/api/v3/#scopes">API Documentation</a>.
                </Typography>
              </Box>
            </Box>

            <Box mb={4}>
              <Typography variant="cardTitle" component="h3">
                <strong>How do I download the actual text responses from my survey?</strong>
              </Typography>
              <Box>
                <Typography>
                  Visit our <a href="/api/v3/">SurveyMonkey API documentation</a> to read about this and the other
                  things you can achieve with our endpoints!
                </Typography>
              </Box>
            </Box>

            <Box mb={4}>
              <Typography variant="cardTitle" component="h3">
                <strong>How do I purchase more API calls?</strong>
              </Typography>
              <Box>
                <Typography>
                  If you&apos;re building a Private app and think you need a higher API limit you should reach out to
                  our <a href={`https://www.${domain}.com/enterprise/`}>sales team</a>.
                </Typography>
              </Box>
            </Box>

            <Box mb={7}>
              <Typography variant="cardTitle" component="h3">
                <strong>How do I revoke an access token?</strong>
              </Typography>
              <Box>
                <Typography>
                  You can refresh your app&apos;s credential in the settings for your app in the{' '}
                  <a href="/apps">developer portal</a>. This will refresh your secret, revoking all access to your app.
                </Typography>
              </Box>
            </Box>

            <Box>
              <Typography align="center">
                Something missing? Reach out through <a href={`https://help.${domain}.com/contact/`}>our help center</a>
              </Typography>
            </Box>
          </Box>
        </div>
      </DeveloperWebBasePage>
    </div>
  );
};

export default FAQ;
